import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import Icona from '../../components/cliente/Icone';
import { Iniziale, dimenticaPersone } from '../../components/staff/Persone';
import '../../components/staff/scheda.css';
import { messaggioErrore } from '../../utils/agenda';

// /admin/collaboratori: lo staff con i clienti che segue, visite, proposte, rogiti, ultimo accesso; gruppo e
// responsabile del gruppo; i clienti pre-registrati con il codice da consegnare; nuovo collaboratore, elimina.
// Dati: GET /api/admin/collaboratori/riepilogo (backend/collaboratori.py).

const quando = (valore) => {
  if (!valore) return 'mai';
  const d = new Date(valore);
  const giorni = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (giorni <= 0) return `oggi ${d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}`;
  if (giorni === 1) return 'ieri';
  if (giorni < 30) return `${giorni} giorni fa`;
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
};

const conta = (n, una, tante) => `${n} ${n === 1 ? una : tante}`;

const errore = (e) => toast.error(messaggioErrore(e));

const NuovoCollaboratore = ({ gruppi, chiudi, onFatto }) => {
  const [d, setD] = useState({ nome: '', cognome: '', email: '', password: '', gruppo_collaboratore: 'admin' });
  const invia = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/admin/collaboratori`, d); toast.success(`${d.nome} è nello staff`); onFatto(); } catch (err) { errore(err); }
  };
  const campo = (k, props = {}) => <input value={d[k]} onChange={(e) => setD({ ...d, [k]: e.target.value })} {...props} />;
  return (
    <div className="riquadro" data-testid="nuovo-collaboratore">
      <div className="ttl" style={{ marginBottom: '.4rem' }}><h2 style={{ fontSize: '1.1rem' }}>Nuovo collaboratore</h2><button type="button" className="x" onClick={chiudi} aria-label="Chiudi">✕</button></div>
      <form onSubmit={invia}>
        <div className="form-griglia">
          <label>Nome{campo('nome', { required: true })}</label>
          <label>Cognome{campo('cognome', { required: true })}</label>
          <label>Email{campo('email', { required: true, type: 'email' })}</label>
          <label>Password provvisoria{campo('password', { required: true, minLength: 8 })}</label>
          <label>Gruppo<input list="gruppi" value={d.gruppo_collaboratore} onChange={(e) => setD({ ...d, gruppo_collaboratore: e.target.value })} /></label>
          <datalist id="gruppi">{gruppi.map((g) => <option key={g} value={g} />)}</datalist>
        </div>
        <div className="form-riga"><button type="submit" className="btn sm p">Crea</button></div>
      </form>
    </div>
  );
};

const Riga = ({ p, gruppi, onFatto }) => {
  const [codici, setCodici] = useState(false);
  const collaboratore = p.ruolo === 'collaboratore';
  const aggiorna = async (corpo) => {
    try { await axios.put(`${API}/admin/collaboratori/${p.id}/gruppo`, corpo); dimenticaPersone(); onFatto(); } catch (e) { errore(e); }
  };
  const elimina = async () => {
    if (!window.confirm(`Eliminare ${p.nome} ${p.cognome}? I suoi ${p.clienti} clienti restano, seguiti dall'admin.`)) return;
    try { await axios.delete(`${API}/admin/collaboratori/${p.id}`); dimenticaPersone(); onFatto(); } catch (e) { errore(e); }
  };
  return (
    <>
      <div className="tr collab" data-testid={`persona-${p.id}`}>
        <div className="nm"><Iniziale persona={p} taglia={34} /><div style={{ minWidth: 0 }}><b>{p.nome} {p.cognome}</b><span>{p.email}</span></div></div>
        <div className="s">
          {collaboratore ? (
            <>
              <select value={p.gruppo || 'admin'} onChange={(e) => aggiorna({ gruppo_collaboratore: e.target.value })} aria-label={`Gruppo di ${p.nome}`}
                style={{ border: '1px solid var(--line2)', borderRadius: 999, padding: '.15rem .5rem', fontSize: '.76rem' }}>
                {[...new Set([...gruppi, p.gruppo || 'admin'])].map((g) => <option key={g} value={g}>{g}</option>)}
              </select>
              <label style={{ display: 'flex', gap: '.35rem', alignItems: 'center', fontSize: '.72rem', marginTop: '.3rem', cursor: 'pointer' }}>
                <input type="checkbox" checked={p.responsabile} onChange={(e) => aggiorna({ responsabile_gruppo: e.target.checked })} aria-label={`${p.nome} responsabile del gruppo`} />
                responsabile del gruppo
              </label>
            </>
          ) : <span className="tag t-o">admin</span>}
        </div>
        <div className="s">{p.clienti} {p.clienti === 1 ? 'cliente' : 'clienti'}<span>{p.clienti_attivi} attivi</span></div>
        <div className="s">{conta(p.visite, 'visita', 'visite')} · {conta(p.proposte, 'proposta', 'proposte')} · {conta(p.rogiti, 'rogito', 'rogiti')}<span>{conta(p.visite_30, 'visita', 'visite')} negli ultimi 30 giorni</span></div>
        <div className="s">{quando(p.ultimo_accesso)}<span>ultimo accesso</span></div>
        <div className="azioni" style={{ display: 'flex', gap: '.3rem' }}>
          {/* il cruscotto del mese di questa persona (pages/staff/CruscottoMese.jsx) */}
          <Link className="btn sm" to={`/admin/collaboratori/${p.id}`} aria-label={`Il mese di ${p.nome}`}>Il mese</Link>
          {p.preregistrati.length > 0 && <button type="button" className="btn sm" onClick={() => setCodici(!codici)} aria-expanded={codici}>Codici ({p.preregistrati.length})</button>}
          {collaboratore && <button type="button" className="x" onClick={elimina} aria-label={`Elimina ${p.nome}`}>✕</button>}
        </div>
      </div>
      {codici && (
        <div className="tr tutti" style={{ textAlign: 'left' }}>
          <div className="rows">
            {p.preregistrati.map((c) => (
              <div key={c.cliente_id} style={{ gridTemplateColumns: 'minmax(0,1fr) auto auto' }}>
                <div><b>{c.nome}</b><span>pre-registrato {quando(c.data)} · non ancora entrato nell'app</span></div>
                <b style={{ fontFamily: 'var(--serif)', color: 'var(--brass2)', letterSpacing: '.1em' }}>{c.codice}</b>
                <Link className="btn sm" to={`/admin/clienti/${c.cliente_id}`}>Apri</Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const Collaboratori = () => {
  const [dati, setDati] = useState(null);
  const [nuovo, setNuovo] = useState(false);
  const [v, setV] = useState(0);
  const ricarica = useCallback(() => setV((x) => x + 1), []);
  useEffect(() => { axios.get(`${API}/admin/collaboratori/riepilogo`).then((r) => setDati(r.data)).catch(() => setDati(false)); }, [v]);
  if (dati === false) return <main className="st wrap"><p className="vuoto">Non riesco a caricare lo staff.</p></main>;
  if (!dati) return <main className="st wrap"><p className="vuoto">Carico lo staff…</p></main>;
  const collab = dati.persone.filter((p) => p.ruolo === 'collaboratore');
  const attesa = dati.persone.flatMap((p) => p.preregistrati.map((c) => ({ ...c, chi: p })));
  return (
    <main className="st wrap" data-testid="collaboratori">
      <div className="head r">
        <div><div className="k">Staff</div><h1>{dati.persone.length} persone, <em>{collab.length} collaboratori</em></h1>
          <p>Chi segue quali clienti, come stanno andando, chi è responsabile del suo gruppo e i codici da consegnare ai clienti pre-registrati.</p></div>
        <div style={{ display: 'flex', gap: '.5rem', flexWrap: 'wrap' }}>
          <button type="button" className="btn p" onClick={() => setNuovo(true)}>+ Nuovo collaboratore</button>
        </div>
      </div>
      {nuovo && <NuovoCollaboratore gruppi={dati.gruppi} chiudi={() => setNuovo(false)} onFatto={() => { setNuovo(false); dimenticaPersone(); ricarica(); }} />}
      <div className="tbl r">
        <div className="tr collab testa"><div>Persona</div><div>Gruppo</div><div>Clienti</div><div>Visite, proposte, rogiti</div><div>Ultimo accesso</div><div /></div>
        {dati.persone.map((p) => <Riga key={p.id} p={p} gruppi={dati.gruppi} onFatto={ricarica} />)}
      </div>
      <section className="card r" style={{ marginTop: '1rem' }} data-testid="codici-preregistrazione">
        <div className="ttl"><div className="i"><Icona nome="chiave" /></div><h2>Clienti non ancora registrati <small>{attesa.length}</small></h2></div>
        <p className="muto" style={{ fontSize: '.82rem', marginBottom: '.6rem' }}>Il cliente scrive il codice quando si registra e ritrova tutto quello che è già stato inserito per lui.</p>
        <div className="rows">
          {!attesa.length && <p className="vuoto">Nessun cliente in attesa di registrarsi.</p>}
          {attesa.map((c) => (
            <div key={c.cliente_id} style={{ gridTemplateColumns: 'auto minmax(0,1fr) auto' }}>
              <Iniziale persona={c.chi} taglia={26} />
              <div style={{ minWidth: 0 }}><b>{c.nome}</b><span>lo segue {c.chi.nome} · codice <b style={{ display: 'inline', color: 'var(--brass2)', letterSpacing: '.08em' }}>{c.codice}</b></span></div>
              <Link className="btn sm" to={`/admin/clienti/${c.cliente_id}`}>Apri</Link>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Collaboratori;
